module.exports = __webpack_public_path__ + "static/media/400394_01.2878078a.png";